import { render, staticRenderFns } from "./DefaultUpdateForm.vue?vue&type=template&id=66ab52f8&"
import script from "./DefaultUpdateForm.vue?vue&type=script&lang=js&"
export * from "./DefaultUpdateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports